import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient/pedido/revisoes/RevisoesPedidoUtilizacaoApiClient'

export default {
	async [actionTypes.PEDIDO.REVISOES.BUSCAR_DISPONIVEL]({ commit }, idPedido) {
		const { data } = await api.buscarRevisoesDisponivel(idPedido)
		commit(mutationTypes.PEDIDO.SET_REVISAO, data)
		return data
	},

	async [actionTypes.PEDIDO.REVISOES.CRIAR](context, { idPedido, body }) {
		await api.criarRevisaoPedidoUtilizacao(idPedido, body)
	},
}
